// Column Configuration
const COLUMN_BASE_STYLE = {
  background: '#f5f5f5',
  fontSize: '20px',
  textAlign: 'center'
};

const COLUMN_COLORS = {
  LEADS: '#6f42c1',
  OPORTUNIDADE: '#007bff',
  POSITIVO: '#28a745',
  NEGATIVO: '#dc3545',
  FOLLOW_UP: '#ffc107',
  NEGOCIACAO: '#17a2b8'
};

// Display order: Leads → Oportunidade → Follow Up → Negociação → Positivo → Negativo
export const STAGE_DISPLAY_ORDER = [1, 2, 5, 6, 3, 4];

export const BASE_COLUMNS = [
  { 
    id: 1, 
    name: 'Leads', 
    style: { ...COLUMN_BASE_STYLE, color: COLUMN_COLORS.LEADS }, 
    leads: [],
    total: 0,
    type: 'base',
    alwaysVisible: true
  },
  { 
    id: 2, 
    name: 'Oportunidade', 
    style: { ...COLUMN_BASE_STYLE, color: COLUMN_COLORS.OPORTUNIDADE }, 
    leads: [],
    total: 0,
    type: 'base',
    alwaysVisible: true
  },
  {
    id: 5,
    name: 'Follow Up',
    style: { ...COLUMN_BASE_STYLE, color: COLUMN_COLORS.FOLLOW_UP },
    leads: [],
    total: 0,
    type: 'base',
    alwaysVisible: true
  },
  {
    id: 6,
    name: 'Negociação',
    style: { ...COLUMN_BASE_STYLE, color: COLUMN_COLORS.NEGOCIACAO },
    leads: [],
    total: 0,
    type: 'base',
    alwaysVisible: true
  },
  {
    id: 3,
    name: 'Positivo', 
    style: { ...COLUMN_BASE_STYLE, color: COLUMN_COLORS.POSITIVO }, 
    leads: [],
    total: 0,
    type: 'base',
    alwaysVisible: false
  },
  { 
    id: 4, 
    name: 'Negativo', 
    style: { ...COLUMN_BASE_STYLE, color: COLUMN_COLORS.NEGATIVO }, 
    leads: [],
    total: 0,
    type: 'base',
    alwaysVisible: false
  }
];

// Default States
// Escala do campo "Potencial" (Rate count={3} no drawer). Há registros
// legados com valores fora dessa faixa (ex.: 1970), que não representam
// classificação e por isso não são exibidos.
export const MAX_LEAD_RATE = 3;

export const DEFAULT_DRAWER_STATE = {
  data: { id: null },
  show: false
};

export const DEFAULT_METRICS_MODAL_STATE = {
  show: false,
  data: null
};

// Lead Categories
export const NECESSITY_TYPES = {
  1: { name: 'Troca de contabilidade', color: 'orange' }, 
  2: { name: 'Abertura de Empresa', color: 'blue' }, 
  3: { name: 'Encerramento de empresa', color: 'red' },
  4: { name: 'BPO Financeiro', color: 'green' },
  5: { name: 'Outros', color: 'gray' },
  6: { name: 'MEI > ME', color: 'purple' }
};

export const TAX_SOFTWARE_TYPES = {
  0: 'SAT',
  1: 'ECF'
};

// Field Configuration for Forms/Tables
export const LEAD_FIELDS = [
  { title: 'Name', name: 'name' },
  { title: 'E-mail', name: 'email' },
  { title: 'Telefone', name: 'phone' },
  { title: 'Data de criação', name: 'registered_at' },
  { title: 'Data de conclusão', name: 'last_column_updated_at' },
  { title: 'Estado', name: 'state' },
  { title: 'Cidade', name: 'city' },
  { title: 'Atividade', name: 'company_type_id' },
  { title: 'Necessidade', name: 'necessity' },
  { title: 'CNPJ', name: 'identification_number' },
  { title: 'Faturamento (mensal)', name: 'billing' },
  { title: 'NFs Entrada (mensal)', name: 'nfs_input' },
  { title: 'NFs Saída (mensal)', name: 'nfs_output' },
  { title: 'Qtd de Boletos', name: 'number_bills' },
  { title: 'Sistema fiscal', name: 'tax_software' },
  { title: 'Funcionários', name: 'n_staffs' },
  { title: 'Qtd de sócios', name: 'n_partners' },
  { title: 'Honorário de abertura', name: 'first_honorary' },
  { title: 'Mensalidade', name: 'honorary' },
  { title: 'Descrição', name: 'description' },
  { title: 'Regime', name: 'type_taxation' },
  { title: 'Motivo de perda', name: 'lost_reason' },
  { title: 'Classificação', name: 'rate' }
];

// Legacy exports for backward compatibility (consider removing after migration)
export const necessity = NECESSITY_TYPES;
export const fields = LEAD_FIELDS;
export const tax_software = TAX_SOFTWARE_TYPES;